import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import useStore from './store/useStore';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import EditorPage from './pages/EditorPage';
import ProfilePage from './pages/ProfilePage';
import FeedbackPage from './pages/FeedbackPage';
import AdminPage from './pages/AdminPage';
import AdminViewerPage from './pages/AdminViewerPage';
import VisionPage from './pages/VisionPage';
import PosterPage from './pages/PosterPage';
import TemplatesPage from './pages/TemplatesPage';
import GuestViewerPage from './pages/GuestViewerPage';
import TemplateEditorPage from './pages/TemplateEditorPage';
import './App.css';

function App() {
  const theme = useStore((s) => s.theme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <BrowserRouter>
      <div className={`app-root ${theme}`}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/editor" element={<EditorPage />} />
          <Route path="/editor/:draftId" element={<EditorPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/view" element={<AdminViewerPage />} />
          <Route path="/vision" element={<VisionPage />} />
          <Route path="/poster" element={<PosterPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/guest/view" element={<GuestViewerPage />} />
          <Route path="/admin/template/new" element={<TemplateEditorPage />} />
          <Route path="/admin/template/edit/:templateId" element={<TemplateEditorPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
